import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import {
	Backdrop,
	Box,
	IconButton,
	Button,
	CircularProgress,
	Container,
	Table,
	Paper,
	Grid,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { styled } from "@mui/material/styles";
import GetAuth from "../../../GetAuth";
import { ref, child, get, getDatabase, set } from "firebase/database";

const Books = () => {
	const [submitting, setSubmitting] = useState(false);
	const [imageLink2, setImageLink2] = useState(null);
	const [deleted, setDeleted] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = React.useState();
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	React.useEffect(() => {
		get(child(dbRef, "josettehill"))
			.then((snapshot) => {
				setLoad(snapshot.val());
				setData(snapshot.val()?.Books?.reverse());
			})
			.catch((error) => {
				console.log(error);
			});
	}, [deleted, dbRef, submitting]);

	const handleDelete = (BooksId) => {
		const filter = load?.Books.filter((g) => g.BooksId !== BooksId);
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				setDeleted(true);
				set(child(dbRef, "josettehill"), {
					...load,
					Books: filter,
				})
					.then(function (response) {
						setDeleted(false);
						Swal.fire("Deleted!", "That image has been deleted.", "success");
					})
					.catch(function (error) {
						console.log(error);
						setDeleted(false);
					});
			}
		});
	};
	const uploadImage = async (e) => {
		const files = e.target.files;
		const data = new FormData();
		data.append("file", files[0]);
		data.append("upload_preset", "Gallery");
		setLoading(true);
		const res = await fetch(
			"https://api.cloudinary.com/v1_1/freedomvirtualsolutions/image/upload",
			{
				method: "POST",
				body: data,
			},
		);
		const file = await res.json();
		setImageLink2(file.secure_url);
		setLoading(false);
	};
	const Input = styled("input")({
		display: "none",
	});
	const [galleryTitle, setGalleryTitle] = useState("");
	const [link, setLink] = useState("");
	const [buttonTitle, setButtonTitle] = useState("");
	const update = () => {
		const data = {
			imageLink2,
			galleryTitle,
			link,
			buttonTitle,
			submitTime: new Date().toLocaleString(),
			BooksId: `Book${Math.floor(100000 + Math.random() * 900000)}`,
		};
		setSubmitting(true);
		set(child(dbRef, "josettehill"), {
			...load,

			Books: [...load?.Books, data],
		})
			.then(function (response) {
				setSubmitting(false);
				setImageLink2(null);
				Swal.fire({
					icon: "success",
					title: "Your photo uploaded Successfully",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	let count = 1;
	return (
		<Container sx={{ pt: 1 }}>
			<Typography
				variant='h4'
				gutterBottom
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				Manage Books
			</Typography>
			<Typography variant='body' gutterBottom className='textColor'>
				Last changed in {data?.[0]?.submitTime || "N/A"}
			</Typography>
			<Box
				display='flex'
				flexDirection='column'
				alignItems='center'
				sx={{ my: 1, mx: "auto" }}>
				{!imageLink2 && (
					<label
						className='bgColor'
						htmlFor='icon-button-file'
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							margin: "0 9px",
							borderRadius: 5,
						}}>
						<Input
							accept='image/*'
							id='icon-button-file'
							type='file'
							onChange={uploadImage}
						/>
						<Typography
							sx={{ my: 2, ml: 2, color: "white" }}
							variant='body1'
							component='div'
							gutterBottom>
							Upload New Books*
						</Typography>
						<IconButton
							sx={{ mx: 2 }}
							color='primary'
							aria-label='upload picture'
							component='span'>
							<AttachFileIcon fontSize='large' sx={{ fontWeight: "bold" }} />
						</IconButton>
					</label>
				)}

				{loading ? (
					<Box sx={{ my: 2 }}>
						<CircularProgress className='textColor' />
					</Box>
				) : (
					<img src={imageLink2} style={{ width: "300px" }} alt='' />
				)}
			</Box>
			{imageLink2 && (
				<>
					<br />
					<TextField
						required
						name='galleryTitle'
						label='Enter Title'
						sx={{ width: "300px", mb: 1 }}
						value={galleryTitle}
						onChange={(e) => setGalleryTitle(e.target.value)}
					/>
					<br />
					<TextField
						required
						name='link'
						label='Enter Link'
						sx={{ width: "300px" }}
						value={link}
						onChange={(e) => setLink(e.target.value)}
					/>
					<br />
					<TextField
						required
						name='buttonTitle'
						label='Enter Button Title'
						sx={{ width: "300px" }}
						value={buttonTitle}
						onChange={(e) => setButtonTitle(e.target.value)}
					/>
					<br />
					<Button
						onClick={update}
						variant='contained'
						component='span'
						className='button border'
						sx={{
							my: 1,
							py: 0.5,
							width: "150px",
							border: "2px solid",
							backgroundColor: "transparent",
						}}>
						Post
					</Button>
				</>
			)}
			<Grid>
				<Paper
					className='container'
					sx={{ overflow: "auto", maxHeight: "85vh", maxWidth: "90vw", m: 2 }}>
					<Table size='small' stickyHeader aria-label='sticky table'>
						<TableHead sx={{ th: { fontWeight: "bold" } }}>
							<TableRow>
								<TableCell align='center' colSpan={4}>
									<Typography
										className='textColor'
										sx={{ fontWeight: "bold" }}
										variant='h4'>
										All Books
									</Typography>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell align='left'>No</TableCell>
								<TableCell align='left'>Image</TableCell>
								<TableCell align='left'>Book</TableCell>
								<TableCell align='left'>Uploaded</TableCell>
								<TableCell align='left'>Action</TableCell>
							</TableRow>
						</TableHead>
						{data?.length > 0 ? (
							<TableBody sx={{ td: { py: 1 } }}>
								{data?.map((image, key) => (
									<TableRow
										key={key}
										sx={{
											"&:last-child td, &:last-child th": { border: 0 },
										}}>
										<TableCell align='left'>{count++}</TableCell>
										<TableCell align='left'>
											<img src={image?.imageLink2} alt='' width='100px' />
										</TableCell>
										<TableCell align='left'>{image?.galleryTitle}</TableCell>
										<TableCell align='left'>{image?.submitTime}</TableCell>
										<TableCell align='left'>
											{data?.length > 1 ? (
												<Button
													className='button border'
													onClick={() => handleDelete(image?.BooksId)}
													sx={{
														fontWeight: "bold",
														border: "2px solid",
														backgroundColor: "transparent",
														borderRadius: "25px",
													}}
													variant='contained'>
													<DeleteIcon />
												</Button>
											) : (
												<Button
													disabled
													sx={{
														fontWeight: "bold",
														border: "2px solid",
														backgroundColor: "gray !important",
														borderRadius: "25px",
													}}
													variant='contained'>
													<DeleteIcon />
												</Button>
											)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						) : (
							<TableHead sx={{ th: { fontWeight: "bold" } }}>
								<TableRow>
									<TableCell align='left'>N/A</TableCell>
									<TableCell align='left'>N/A</TableCell>
									<TableCell align='left'>N/A</TableCell>
									<TableCell align='left'>N/A</TableCell>
								</TableRow>
							</TableHead>
						)}
					</Table>
				</Paper>
			</Grid>{" "}
			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={!load || submitting || deleted}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default Books;
